import NonBlockedOccupationLogicService from '../../../../services/non_blocked_occupation_logic_service'

$(document).on('ready', () => {
  if ($('#managers-general_pages-dashboard').length !== 0) {
    $(document).on('total-occupation-list-loaded', () => {
      new NonBlockedOccupationLogicService().setup()
    })
  }
})
